import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import VolteCheckBlockData from 'Models/Content/VolteCheckBlockData';
import VolteCheckComponentCellcom from './Cellcom/VolteCheckComponentCellcom';
import VolteCheckComponentDynamica from './Dynamica/VolteCheckComponentDynamica';

export default class VolteCheckBlock extends EpiComponent<VolteCheckBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    const isDynamicaHosted = this.props.data.isDynamicaHosted?.value;
    const iContent = this.props.data;
    const context = this.getContext();
    let blockContent;
    if (isDynamicaHosted) {
      blockContent = <VolteCheckComponentDynamica iContent={iContent} context={context} />;
    } else {
      blockContent = <VolteCheckComponentCellcom iContent={iContent} context={context} />;
    }
    return <div className={`VolteCheckBlock ${isDynamicaHosted ? 'volteDynamicaBlock' : ''}`}>{blockContent}</div>;
  }
}
